/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID & ULID Inspector`)
};

const es_ud_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector UUID e ULID`)
};

const de_ud_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID & ULID Inspector`)
};

const nl_ud_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID & ULID Inspector`)
};

const fr_ud_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecteur UUID et ULID`)
};

const it_ud_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ispettore UUID e ULID`)
};

const pt_br2_ud_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de UUID e ULID`)
};

const pt_ud_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de UUID e ULID`)
};

const ja_ud_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID & ULID インスペクター`)
};

const zh_ud_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID 与 ULID 检查器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_tool_name", locale)
	if (locale === "en") return en_ud_tool_name(inputs)
	if (locale === "es") return es_ud_tool_name(inputs)
	if (locale === "de") return de_ud_tool_name(inputs)
	if (locale === "nl") return nl_ud_tool_name(inputs)
	if (locale === "fr") return fr_ud_tool_name(inputs)
	if (locale === "it") return it_ud_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_ud_tool_name(inputs)
	if (locale === "pt") return pt_ud_tool_name(inputs)
	if (locale === "ja") return ja_ud_tool_name(inputs)
	return zh_ud_tool_name(inputs)
};